import uuid from 'uuid-random';
import { addPopupAction, LAYER } from 'js/components/common/PopupManager';

import { MultiFactorAuthenticationPopup } from '../MultiFactorAuthenticationPopup';

const popupId = uuid();

export const showMultiFactorAuthenticationPopupAction = (data = {}) => addPopupAction({
    id: popupId,
    layer: LAYER.SESSION_VALIDATION,
    component: MultiFactorAuthenticationPopup,
    ...data
});
